import * as customerEffects from './customer/customer.effects'
import { sharedEffects, userEffects } from 'shared-lib'

export const effects = { ...userEffects, ...customerEffects, ...sharedEffects }
